import { render, staticRenderFns } from "./UploaderFile.vue?vue&type=template&id=409f63aa&scoped=true"
import script from "./UploaderFile.vue?vue&type=script&lang=js"
export * from "./UploaderFile.vue?vue&type=script&lang=js"
import style0 from "./UploaderFile.vue?vue&type=style&index=0&id=409f63aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f63aa",
  null
  
)

export default component.exports